import NoContractJSON from '../../assets/animation-json/NoContracts.json';
import ContactPopupModal from '../contact/popupModel/contactPopupModel';

import Lottie from 'lottie-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './NoContract.css';

const NoContract = () => {
  const [visible, setVisible] = React.useState(false);
  const {t} = useTranslation();
  return (
    <>
      <div className="no-contract" data-testid="no-contract">
        <div className="no-contract-wrapper">
          <div className="no-contract-image">
            <Lottie animationData={NoContractJSON} loop={true} />
          </div>
          <div className="no-contract-text">
            <div className="nocontract-heading">{t('WELCOME_MYFINANCIAL')}</div>
            <div className="nocontract-subheading">
              {t('NO_CONTRACT_TITLE')}
            </div>
          </div>
        </div>
      </div>
      <ContactPopupModal
        id="ContactPopupModal"
        title={''}
        visible={visible}
        setVisible={setVisible}
      />
    </>
  );
};

export default NoContract;
